var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Bar"},_vm._l((_vm.echartsOptions),function(item,index){return _c('div',{key:index,staticClass:"echarts-view",attrs:{"id":'EchartsBar'+item.numCharts}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }